// Ratios stay in saved projects/API payloads for backwards compatibility;
// the editor presents their distance from the target as percentages.
export const LEGACY_CAPACITY_RATIOS = { undersizeRatio: 0.99, oversizeRatio: 1.05 };
export const NEW_CAPACITY_RATIOS = { undersizeRatio: 0.9, oversizeRatio: 1.1 };

export function tolerancePercent(ratio, lower = false) {
  if (ratio === "" || ratio == null) return "";
  return Number(((Number(ratio) - 1) * (lower ? -100 : 100)).toFixed(8));
}

export function toleranceRatio(percent, lower = false) {
  if (percent === "") return "";
  return Number((1 + Number(percent) / (lower ? -100 : 100)).toFixed(10));
}

export function validCapacityRatios(lower, upper) {
  return Number.isFinite(lower) && lower > 0 && lower <= 1 &&
    Number.isFinite(upper) && upper >= 1;
}
